/**
 * Ingestion Service API Client
 *
 * Lightweight client for the ingestion service (port 4100), separate from
 * the main API service (port 4000). Used by the CSV upload flow to submit
 * parsed track data via the JSON_CUSTOM adapter.
 */

import axios from 'axios';

const INGESTION_URL =
  import.meta.env.VITE_INGESTION_URL || 'http://localhost:4100';

const ingestionClient = axios.create({
  baseURL: INGESTION_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30_000,
});

/**
 * Send a batch of mapped track rows to the ingestion service.
 */
export async function sendBatch(
  rows: Record<string, unknown>[],
  sensorId: string,
  tenantId: string,
  sensorType: string,
): Promise<{ status: number; data: unknown }> {
  const response = await ingestionClient.post('/ingest', rows, {
    headers: {
      'x-sensor-id': sensorId,
      'x-tenant-id': tenantId,
      'x-data-format': 'JSON_CUSTOM',
      'x-sensor-type': sensorType,
    },
  });
  return { status: response.status, data: response.data };
}
